import { useState } from 'react'

import { Container, Page, Filters, Header } from 'components'
import { makeStyles, Grid, IconButton, ButtonBase } from '@material-ui/core'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'

import styles from './styles'
import * as service from 'service'
import { DialogBankAccountCreation, CardComponent } from './components'

import { routes } from 'Routes'

import { Plus as PlusIcon } from 'react-feather'

const useStyles = makeStyles(styles)

const BankAccountsMain = () => {
  const [openCreationDialog, setOpenCreationDialog] = useState(false)
  const classes = useStyles()
  const filter = useFilter()

  const { response, refresh } = useFetch(
    service.intermediador.bankAccounts.get,
    { ...{ ...filter.filters }, page: 1, perPage: 1000 },
    [1, 1000, filter.filters],
  )

  return (
    <Page className={classes.root} title="Conta bancária">
      <Container maxWidth="md">
        <Grid container spacing={8}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Header name="Conta bancária" route={routes.settings.main} />
          </Grid>
          {/* <Grid item xs={12} sm={12} md={2} lg={2}>
            <FilterButton setDrawerOpen={filter.setDrawerOpen} />
          </Grid> */}
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <ButtonBase
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '20px',
                width: '100%',
                height: '100%',
              }}
              onClick={() => setOpenCreationDialog(true)}
            >
              <IconButton color="secondary" component="span">
                <PlusIcon size={32} />
              </IconButton>
            </ButtonBase>
          </Grid>
          {response?.data?.bankAccounts.map((value) => (
            <Grid item xs={12} sm={12} md={4} lg={4} key={value?.id}>
              <CardComponent value={value} refresh={refresh} />
            </Grid>
          ))}

          {/* <Grid container spacing={3}>
            <Grid item lg={9}>
              <BankAccountsDetail bankAccount={bankAccountActive} />
            </Grid>
            <Grid item lg={12} xs={12}>
              <BankAccountsTable
                isLoading={isLoading}
                bankAccounts={response?.data?.bankAccounts}
                bankAccountActive={bankAccountActive}
                setBankAccountActive={setBankAccountActive}
              />
            </Grid>
          </Grid> */}
        </Grid>
      </Container>
      <DialogBankAccountCreation
        open={openCreationDialog}
        refresh={refresh}
        setOpen={setOpenCreationDialog}
      />
      <Filters filter={filter}>
        <input textfieldinput="true" label="Documento" name="document" />
      </Filters>
    </Page>
  )
}

export default BankAccountsMain
